export default `{
  "premium_proxies": true
}`